import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { fetchInvestorDetails } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { BANK } from '../../../../redux-store/types/nct';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import { BANK_ACCOUNT_DETAILS, DEBT, EQUITY, LIQUID, OTHER } from '../../../../utils/constants';
import { getMatchAndUnMatchedFunds, maskMobileNumber } from '../../../../utils/utilityFunctions';
import {
    getErrorMessage,
    getInvestorFunds,
    notLockedFolio,
    portfoliosByMinorStatus,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import NoFoliosFound from '../NoFoliosFound';
const { dashboard } = en;

export const findDefaultBank = (row: any) => {
    return row?.bank.find((details: BANK) => details.default === 'Y') || row?.bank[0];
};

export const findDefaultBankIndex = (row: any) => {
    const NOT_FOUND = -1;
    const defaultBankIndex = row?.bank.findIndex((details: BANK) => details.default === 'Y');
    return defaultBankIndex === NOT_FOUND ? 0 : defaultBankIndex;
};

export const ChangeBankColumns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
    },
    {
        field: 'amcName',
        headerName: 'Fund House',
        width: 250,
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    {
        field: 'bank',
        headerName: 'BANK NAME',
        valueGetter: ({ row }) => findDefaultBank(row).name || dashboard.notAvailable,
        width: 150,
    },
    {
        field: 'accountNo',
        headerName: 'Account No.',
        valueGetter: ({ row }) =>
            maskMobileNumber(findDefaultBank(row)?.accountNo) || dashboard.notAvailable,
        width: 100,
    },
    {
        field: 'ifsc',
        headerName: 'IFSC',
        valueGetter: ({ row }) => {
            const defaultBank: BANK = findDefaultBank(row);
            return defaultBank?.ifsc || defaultBank.neftIfsc || dashboard.notAvailable;
        },
        width: 200,
    },
    {
        field: 'investorName',
        headerName: 'PRIMARY HOLDER',
        valueGetter: ({ row }) => (row?.investorName || '').toUpperCase() || dashboard.notAvailable,
        width: 100,
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function ChangeBank(props: any) {
    const [rowData, setRowdata] = useState<ConsolidateTableRowType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const {
        selectedRows: targetFunds,
        setSelectedRows: setTargetFunds,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<ConsolidateTableRowType[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns: ChangeBankColumns,
        loading,
    });

    useEffect(() => {
        setLoading(true);
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            try {
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                const { success: investorFundDetails = [] } = investorDetails;
                const bankFundRowData = getInvestorFunds(investorFundDetails, [
                    portfoliosByTransactionResource,
                    ({ bank = [] }: ConsolidateTableRowType): boolean =>
                        bank.findIndex(
                            (details: BANK) => details.default === 'Y' || details.default === '',
                        ) !== -1,
                ]);
                const processedData = getMatchAndUnMatchedFunds(
                    [notLockedFolio],
                    bankFundRowData,
                    true,
                );
                setRowdata(processedData);
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => { };
    }, []);

    const _isRowSeletable = ({ row }: { row: ConsolidateTableRowType }) => {
        if ((row as any).isDisabled) {
            return false;
        }
        if (targetFunds.length) {
            const [fund] = targetFunds;

            const rowDefaultBankIndex = findDefaultBankIndex(row);
            const fundDefaultBankIndex = findDefaultBankIndex(fund);

            const bankIfsc = fund.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();
            const rowIfsc = row.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();

            const accountNo = fund.bank[rowDefaultBankIndex]?.accountNo;
            const rowAccountNo = row.bank[rowDefaultBankIndex]?.accountNo;

            if (!(bankIfsc === rowIfsc && accountNo === rowAccountNo)) {
                return false;
            }
        }
        return true;
    };

    const _toolTipGetText = ({ row }: { row: ConsolidateTableRowType }) => {
        if ((row as any).isDisabled) {
            return getErrorMessage(row, [notLockedFolio]);
        }
        if (targetFunds.length) {
            const [fund] = targetFunds;

            const rowDefaultBankIndex = findDefaultBankIndex(row);
            const fundDefaultBankIndex = findDefaultBankIndex(fund);

            const bankIfsc = fund.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();
            const rowIfsc = row.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();

            const accountNo = fund.bank[rowDefaultBankIndex]?.accountNo;
            const rowAccountNo = row.bank[rowDefaultBankIndex]?.accountNo;

            if (!(bankIfsc === rowIfsc && accountNo === rowAccountNo)) {
                return dashboard.ChangeBank.tooltip.info1;
            }
        }
        return '';
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.ChangeBank.ChangeBankHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5>
                        {' '}
                        {dashboard.ChangeBank.ChangeBankInfo}
                        <span>{dashboard.ChangeBank.Note}</span>
                    </h5>
                    <div className="curved-table-content">
                        {!loading && !tableRows.length ? (
                            <NoFoliosFound />
                        ) : (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={_isRowSeletable}
                                toolTipTextGetter={_toolTipGetText}
                                selectedRows={targetFunds}
                                setSelectedRows={setTargetFunds}
                                disableAllSelection
                                toolTipEnabled
                                checkBoxEnabled
                                {...filters}
                            />
                        )}
                    </div>
                    <FaqLink section={BANK_ACCOUNT_DETAILS} history={props.history} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <SubmitButton
                                disabled={!targetFunds.length}
                                label={dashboard.ChangeBank.buttonText}
                                className="customBtn"
                                onClick={() =>
                                    props.history.push('change-bank-selected', {
                                        targetFunds,
                                    })
                                }
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
})(ChangeBank);
